module.exports = __webpack_public_path__ + "img/no_list_icon.8e0f8e04.png";